import React, { useState } from "react";
import { Form, FormGroup, Label, Input, Button } from "reactstrap";
import APIURL from "../../../helper/environment";
const EditLot = ({ data, onUpdate }) => {
  const [name, setName] = useState(data.name);
  const [description, setDescription] = useState(data.description);
  const [streetAddress, setStreetAddress] = useState(data.streetAddress);
  const [cityAddress, setCityAddress] = useState(data.cityAddress);
  const [zipcodeAddress, setZipcodeAddress] = useState(data.zipcodeAddress);
  const [contactPhoneNumber, setContactPhoneNumber] = useState(
    data.contactPhoneNumber
  );
  const [totalParkingSpots, setTotalParkingSpots] = useState(
    data.totalParkingSpots
  );
  const [availableParkingSpots, setAvailableParkingSpots] = useState(
    data.availableParkingSpots
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    const updatedData = {
      name,
      description,
      streetAddress,
      cityAddress,
      zipcodeAddress,
      contactPhoneNumber,
      totalParkingSpots,
      availableParkingSpots,
    };

    try {
      const response = await fetch(`${APIURL}/parking-lot/edit/${data.id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedData),
      });

      if (response.ok) {
        onUpdate(updatedData); // Trigger the update logic in the parent component
      } else {
        console.error("Error:", response.status);
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  return (
    <Form className="mb-4" onSubmit={handleSubmit}>
      <h3>Edit Parking Lot</h3>
      <FormGroup>
        <Label for="name">Name:</Label>
        <Input
          type="text"
          id="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </FormGroup>
      <FormGroup>
        <Label for="description">Description:</Label>
        <Input
          type="text"
          id="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </FormGroup>
      <FormGroup>
        <Label for="streetAddress">Street Address:</Label>
        <Input
          type="text"
          id="streetAddress"
          value={streetAddress}
          onChange={(e) => setStreetAddress(e.target.value)}
        />
      </FormGroup>
      <FormGroup>
        <Label for="cityAddress">City Address:</Label>
        <Input
          type="text"
          id="cityAddress"
          value={cityAddress}
          onChange={(e) => setCityAddress(e.target.value)}
        />
      </FormGroup>
      <FormGroup>
        <Label for="zipcodeAddress">Zipcode Address:</Label>
        <Input
          type="number"
          id="zipcodeAddress"
          value={zipcodeAddress}
          onChange={(e) => setZipcodeAddress(e.target.value)}
        />
      </FormGroup>
      <FormGroup>
        <Label for="contactPhoneNumber">Contact Phone Number:</Label>
        <Input
          type="tel"
          id="contactPhoneNumber"
          value={contactPhoneNumber}
          onChange={(e) => setContactPhoneNumber(e.target.value)}
        />
      </FormGroup>
      <FormGroup>
        <Label for="totalParkingSpots">Total Parking Spots:</Label>
        <Input
          type="number"
          id="totalParkingSpots"
          value={totalParkingSpots}
          onChange={(e) => setTotalParkingSpots(e.target.value)}
        />
      </FormGroup>
      <FormGroup>
        <Label for="availableParkingSpots">Available Parking Spots:</Label>
        <Input
          type="number"
          id="availableParkingSpots"
          value={availableParkingSpots}
          onChange={(e) => setAvailableParkingSpots(e.target.value)}
        />
      </FormGroup>
      <div className="d-grid gap-2 mb-4">
        <Button type="submit" color="primary">
          Update
        </Button>
      </div>
    </Form>
  );
};

export default EditLot;
